module.exports ={
    menuButtonHeight: '5.625vh',
    backButtonHeight: '5.625vh'
}


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/MiamiConstants.js